// extracted by mini-css-extract-plugin
module.exports = {"vantageBlue":"#3f1f5a","tfButton":"TfButton_tfButton__3xXhh","ant-btn":"TfButton_ant-btn__1gjLu"};